import { render } from "./RegistryHub.vue?vue&type=template&id=2de1bfb3&scoped=true"
import script from "./RegistryHub.vue?vue&type=script&lang=js"
export * from "./RegistryHub.vue?vue&type=script&lang=js"

import "./RegistryHub.vue?vue&type=style&index=0&id=2de1bfb3&lang=css"
import "./RegistryHub.vue?vue&type=style&index=1&id=2de1bfb3&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de1bfb3"]])

export default __exports__